import { createFileRoute } from "@tanstack/react-router";

import { CreatePasswordPage } from "@/features/users/createPassword";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/create-password")({
  component: RouteComponent,
  validateSearch: (search) => {
    if (!search.token) {
      throw new Error("Invalid or missing token");
    }

    return {
      token: search.token,
    };
  },
});

function RouteComponent() {
  usePageTitle("Create Password");

  return <CreatePasswordPage />;
}
